/* @ngInject */
function FloatingBarAdminController ($rootScope, $scope, $q, $translate, ModalService, UdsModalService, MessageService, ArtsService, ToastService) {
  const getMoveTemplateCollectionController = () => $q.when(import('../../dialogs/move-template-collection/move-template-collection-dialog.controller'))
  const getArchiveCollectionsAndTemplatesDialogController = () => $q.when(import('../../dialogs/archive-collections-and-templates/archive-collections-and-templates-dialog.controller'))
  const getUnarchiveTemplateDialogController = () => $q.when(import('../../dialogs/unarchive-template/unarchive-template-dialog.controller'))

  const api = {
    getMoveTemplateCollectionController,
    getArchiveCollectionsAndTemplatesDialogController,
    getUnarchiveTemplateDialogController,
    _batchUnarchiveTemplates,
    _emitReloadPage,
    _emitRefreshPage
  }

  $scope.shouldShowMoreOptions = () => {
    const isInMaterials = $scope.location === 'materials'
    const isNotArchived = !$scope.isArchivedFilter
    const noCollectionsSelected = $scope.selectedCollections?.length === 0
    const hasTemplatesSelected = $scope.selectedTemplates?.length > 0

    if (!isInMaterials) return false

    if (isNotArchived) return true

    return noCollectionsSelected && hasTemplatesSelected
  }

  this.getApi = () => api

  activate()

  function activate () {
  }

  $scope.unselectAllAssets = () => {
    $scope.onUnselectAllAssets()
  }

  $scope.openOrganizeDialog = function () {
    return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
      ModalService.showModal({
        templateId: 'moveTemplateCollection.html',
        templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: MoveTemplateCollectionController,
        data: {
          data: {
            collections: $scope.selectedCollections || [],
            templates: $scope.selectedTemplates || []
          },
          type: 'multiple'
        }
      }).then(info => {
        if (info && info.changed && !$scope.isProductList) {
          api._emitReloadPage()
        } else if (info && info.changed && $scope.isProductList) {
          api._emitRefreshPage(info.in, info.to)
        }
      })
    })
  }

  function _emitRefreshPage (inId = null, toId = null) {
    $rootScope.$emit('templates-collections.deselect')
    $scope.$emit('refresh-arts-page', { sectionId: inId, targetId: toId })
  }

  function _emitReloadPage (emitter = 'default', data = {}) {
    $rootScope.$emit('templates-collections.deselect')
    $scope.$emit('reload-arts-page', { emitter, ...data })
  }

  $scope.getFloatingBarTitle = () => {
    const templatesCount = $scope.selectedTemplates?.length || 0
    const collectionsCount = $scope.selectedCollections?.length || 0
    const textNeedsPlural = (templatesCount + collectionsCount) > 1

    if (textNeedsPlural) {
      return $translate.instant('selectedsLowerCase')
    }

    return $translate.instant('selectedLowerCase')
  }

  $scope.getFloatingBarCounter = () => {
    const templatesCount = $scope.selectedTemplates?.length || 0
    const collectionsCount = $scope.selectedCollections?.length || 0

    return templatesCount + collectionsCount
  }

  $scope.getTooltipContent = () => {
    if ($scope.location === 'archivedArtList') {
      return $translate.instant('unarchive')
    } else {
      return $translate.instant('archive')
    }
  }

  $scope.archiveSelectedFoldersAndTemplates = () => {
    const collectionIds = $scope.selectedCollections.map(collection => collection.id)
    const templateIds = $scope.selectedTemplates.map(template => template.id)
    api.getArchiveCollectionsAndTemplatesDialogController().then(({ ArchiveCollectionsAndTemplatesDialogController }) => {
      const archiveCollectionsAndTemplatesDialog = UdsModalService.createModal({
        controller: ArchiveCollectionsAndTemplatesDialogController,
        modalName: 'archiveCollectionsAndTemplatesDialog',
        data: {
          collectionIds,
          templateIds,
          isProductList: $scope.isProductList,
          selectedTemplates: $scope.selectedTemplates,
          selectedCollections: $scope.selectedCollections
        }
      })

      archiveCollectionsAndTemplatesDialog.open()
    })
  }

  $scope.unarchiveSelectedTemplates = () => {
    const templatesAreNotCustomizable = $scope.selectedTemplates?.every(template => !template.isCustomizable)
    const ids = $scope.selectedTemplates?.map(item => item.id)

    if (templatesAreNotCustomizable) {
      MessageService.warning({
        title: $translate.instant('beware'),
        text: $translate.instant('areYouSureUnarchiveTemplate'),
        confirmButton: $translate.instant('unarchive'),
        cancelButton: $translate.instant('cancel'),
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: true,
        press: () => {
          api._batchUnarchiveTemplates(ids)
        }
      })
      return
    }

    api.getUnarchiveTemplateDialogController().then(({ unarchiveTemplateController }) => {
      ModalService.showModal({
        templateId: 'unarchiveTemplate.html',
        templateUrl: '/arts/dialogs/unarchive-template/unarchive-template-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: unarchiveTemplateController,
        data: {
          data: {
            isArchivingMultiples: true,
            templateIds: ids
          }
        }
      }).then(() => {
        if ($scope.isProductList) {
          api._emitRefreshPage(null, $scope.selectedTemplates?.[0]?.artCollectionId)
        } else {
          $rootScope.$broadcast('reload-arts-page')
          api._emitReloadPage()
        }
      })
    })
  }

  function _batchUnarchiveTemplates (templateIds) {
    function _unarchiveTemplatesCallBack () {
      return ArtsService.bulkUnarchiveTemplates(templateIds)
        .then(() => {
          ToastService.defaultSuccessToast()
          $rootScope.$broadcast('reload-arts-page')
          api._emitReloadPage()
        })
    }

    return $scope.openOrganizeDialog().then(() => {
      return _unarchiveTemplatesCallBack()
    })
  }
}

export { FloatingBarAdminController }
